import i18n from '@/plugins/i18n/index'

export const operatorRoles = [
  {
    id: 1,
    text: 'Super Admin',
    slug: 'admin',
    searchId: '1',
  },
  {
    id: 4,
    text: i18n.global.t('Loader Operator'),
    slug: 'loader_operator',
    searchId: '4',
  },
  {
    id: 5,
    text: i18n.global.t('Trucker Operator'),
    slug: 'trucker_operator',
    searchId: '5',
  },
  {
    id: 6,
    text: i18n.global.t('Accounts Operator'),
    slug: 'account_operator',
    searchId: '6',
  },
]

export const operatorsHeaders = [
  { title: i18n.global.t('ID'), key: 'id', sortable: false },
  { title: i18n.global.t('Full Name'), key: 'fullname', align: 'start', sortable: false },
  { title: i18n.global.t('Mobile No.'), key: 'mobiles', sortable: false },
  { title: i18n.global.t('Email Address'), key: 'email', align: 'start', sortable: false },
  { title: i18n.global.t('Role'), key: 'role', align: 'start', sortable: false },
  { title: i18n.global.t('Actions'), key: 'actions', sortable: false, align: 'center' },
]

export const operatorTableOptions: Record<string, any> = reactive({
  page: 1,
  limit: 10,
  sortField: null,
  sortOrder: null,
  search: false,
})

export const adminRoleSlug = 'admin'

export const adminRoleId = '1'

export const roleWarning = 'The assigned role for this operator is permanent and cannot be modified after saving. Do you want to continue?'

export const roleSlug: Record<string, any> = {
  'Trucker Operator': 'truck_operator',
  'Loader Operator': 'load_operator',
  'Accounts Operator': 'account_operator',
}

export const documentTypes: Record<string, any> = {
  'Trucker Operator': 'truck_operator',
  'Loader Operator': 'load_operator',
  'Accounts Operator': 'account_operator',
}
